export default "__VITE_ASSET__DKb7fgf1__"